import ErrorBoundary from '@/gf/components/ErrorBoundary'
import HashLinks from '@/gf/components/HashLinks'
import ConfigProvider from '@/gf/providers/ConfigProvider'
import ErrorTrackerProvider from '@/gf/providers/ErrorTracker'
import StableNavigateProvider from '@/gf/providers/StableNavigateProvider'
import qs from 'query-string'
import { Navigate, Route, Routes } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6'
import About from './pages/About'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import OAuth from './pages/OAuth'
import PartsHub from './pages/PartsHub'
import Pricing from './pages/Pricing'
import Remote from './pages/Remote'
import SalesHub from './pages/SalesHub'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import LegacyGqlClientProvider from './providers/GqlClient'
import GqlClientProvider from './providers/GqlClientNext'
import SessionProvider from './providers/SessionProvider'
import ROICalculator from './pages/ROICalculator'

const App = () => (
  <ConfigProvider>
    <ErrorTrackerProvider>
      <ErrorBoundary>
        <GqlClientProvider>
          <LegacyGqlClientProvider>
            <SessionProvider>
              <StableNavigateProvider>
                <QueryParamProvider
                  adapter={ReactRouter6Adapter}
                  options={{
                    searchStringToObject: qs.parse,
                    objectToSearchString: qs.stringify,
                  }}
                >
                  <HashLinks />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/how-it-works" element={<Navigate to="/parts-hub" replace />} />
                    <Route path="/parts-hub" element={<PartsHub />} />
                    <Route path="/sales-hub" element={<SalesHub />} />
                    <Route path="/pricing/*" element={<Pricing />} />
                    <Route path="/roi-calculator" element={<ROICalculator />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/signup" element={<Navigate to="/signup/parts-hub" replace />} />
                    <Route path="/signup/:app/*" element={<SignUp />} />
                    <Route path="/oauth/*" element={<OAuth />} />
                    <Route path="/login" element={<SignIn />} />
                    {[
                      'press',
                      'careers',
                      'terms-and-conditions',
                      'supplier-terms-and-conditions',
                      'privacy-policy',
                      'contact-us',
                    ].map((slug) => (
                      <Route path={`/${slug}`} element={<Remote />} key={slug} />
                    ))}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </QueryParamProvider>
              </StableNavigateProvider>
            </SessionProvider>
          </LegacyGqlClientProvider>
        </GqlClientProvider>
      </ErrorBoundary>
    </ErrorTrackerProvider>
  </ConfigProvider>
)

export default App
